import React, {useEffect, useLayoutEffect, useState, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import './Player.sass'
import {gsap} from "gsap";
import _ from 'lodash';
import config from "../config/config_data";
import Menu from './Menu/Menu';
import Page from './Page/Page';
import Resources from "./Resources/Resources";
import HeaderNav from "./HeaderNav/HeaderNav";
import FooterNav from "./FooterNav/FooterNav";
import Alert from "./Alert/Alert";
import {
    setAlert,
    initializeCourse,
    setAudio,
    gotoLocation,
    gotoPreviousPage
} from "../store/actions/course.action";
import {SCORM} from "../api/SCORM_API_wrapper";
import {withScorm} from "../scorm";
import apiJSON from "../api/apiJSON";
import Loader from 'react-loader-spinner'
import Image from "./Page/components/Image/Image";

const Player = (props) => {
    const {
        courseData,
        courseInitialized,
        courseLocation,
        alertData,
        background,
        courseStatus,
        pageStatus
    } = useSelector((state) => state.course);
    const {resourcesVisible, resourcesSelection} = useSelector((state) => state.course);
    const [seenCompletedAlert, setSeenCompletedAlert] = useState(false);
    const [chapterIndex, pageIndex] = courseLocation;
    const [pageData, setPageData] = useState(null);
    const [fadeOutComplete, setFadeOutComplete] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false)
    const [imagesLoaded, setImagesLoaded] = useState(false)
    const dispatch = useDispatch();
    const courseJson = apiJSON.get(config.base_path + "/json/course_data.json");
    const blocker = useRef();

    useEffect(() => {
        console.log("Player init useEffect()");

        let lms = SCORM.API.isFound
        let tempStatus = [];
        let loc = [-1, -1];
        if (lms) {

            let sd = SCORM.data.get("cmi.suspend_data");
            if (sd) {
                let sdata = JSON.parse(sd)
                console.log("   sdata.progress: ", sdata.progress);
                if (sdata.progress) {
                    tempStatus = restructurePageStatus(sdata.progress, courseJson);
                }
            }
            console.log("    INITIALIZED!!!");
        }
        if (tempStatus.length === 0) {
            tempStatus = initializePageStatus(courseJson);
        }

        dispatch(initializeCourse({
            courseData: courseJson,
            pageStatus: tempStatus,
            courseInitialized: true,
            debug: courseJson.debug,
            lmsEnabled: lms
        }))
    }, []);

    useEffect(() => {
        if (courseData && courseData.autoStart) {
            dispatch(gotoLocation([0, 0]));
        }
    }, [courseInitialized]);


    useEffect(() => {
        console.log("Player courseLocation updated()");
        gsap.set(".blocker", {"visibility": "visible", "opacity": 1})
        dispatch(setAudio(null));
        setPageLoaded(false);
        setFadeOutComplete(false);
        let statusStr;
        if (pageStatus && pageStatus.length > 0) {
            statusStr = pageStatusToString(pageStatus)
            console.log("   statusStr: ", statusStr)
        }
        if (courseStatus === "completed" && !seenCompletedAlert) {
            let alert = (courseData.alerts && (_.find(courseData.alerts, {"id": "completed"})));
            dispatch(setAlert(alert));
            setSeenCompletedAlert(true);
        }
        let lms = SCORM.API.isFound
        if (lms) {
            //loc = SCORM.data.get("cmi.core.lesson_location");
            //console.log("   loc: ", loc);
            SCORM.data.set("cmi.suspend_data", statusStr);
            SCORM.data.set("cmi.core.lesson_location", courseLocation.toString())
        }
    }, [courseLocation]);

    useEffect(() => {
        if (!pageLoaded) {
            if (courseLocation[0] !== -1) {
                //preload page assets
                let pageData = courseData.content[chapterIndex].pages[pageIndex]
                let {elements} = pageData
                //console.log("   elements: ", elements);
                let imageArray = [];
                if (pageData.background) {
                    imageArray.push(pageData.background)
                }
                elements.map((element) => {
                    if (element.animations) {
                        element.id = element.id || _.uniqueId(element.type)
                        if (element.type === "image") {
                            imageArray.push(element.url)
                        }
                    }
                })
                if (imageArray.length > 0) {
                    cacheImages(imageArray).then(() => {
                        console.log("Cached Images 1")
                    })
                }
            } else {
                //preload menu bg
                if (background) {
                    cacheImages([background]).then(() => {
                        console.log("Cached Images 2")
                    })
                }
            }
            setImagesLoaded(true)
            gsap.fromTo(blocker.current, {"opacity": 1}, {"opacity": 0, onComplete: completeFadeOut, duration: 0.3})
            //blocker.current.style.animation = "fade-out 1s"
            //blocker.current.addEventListener("animationend",()=>{completeFadeOut()})
        }
    }, [pageLoaded, imagesLoaded])

    const completeFadeOut = () => {
        setFadeOutComplete(true)
    }

    useEffect(() => {
        if (fadeOutComplete) {
            gsap.set(".blocker", {"visibility": "hidden"});
            if (chapterIndex !== -1) {
                setPageData(courseData.content[chapterIndex].pages[pageIndex]);
            }
            setPageLoaded(true);
        }
    }, [fadeOutComplete]);


    const cacheImages = async (imgElements) => {
        console.log("Player cacheImages(", imgElements, ")");
        const imgLoadedPromises = imgElements.map(url => {
            return new Promise((resolve, reject) => {
                const img = new Image()
                img.src = url
                img.onload = resolve
                img.onerror = reject
            }).catch((err) => {
                console.log("   err: ", err);

            })
        })

        await Promise.all(imgLoadedPromises)
        setImagesLoaded(true)
    }

    useEffect(() => {
        let lms = SCORM.API.isFound
        if (lms) {
            SCORM.data.set("cmi.core.lesson_status", courseStatus)
        }
    }, [courseStatus]);


    useEffect(() => {
        let r = document.querySelector(".Resources")
        if (!r) return;
        if (resourcesVisible) {
            gsap.to(".Resources", {autoAlpha: 1})
        } else {
            gsap.to(".Resources", {autoAlpha: 0, duration: 1})
        }
    }, [resourcesVisible]);

    const pageStatusToString = (ps) => {
        let str = "";
        for (let i = 0; i < ps.length; i++) {
            let chapter = ps[i];
            str += chapter.toString();
            if (i < ps.length - 1) {
                str += "|"
            }
        }
        return str
    }

    const restructurePageStatus = (str, data) => {
        let result = [];
        let err = false;
        let chapters = str.split("|");
        chapters.map((c, index) => {
            let chapter = data.content[index];
            let pages = c.split(",");
            let ps = [];
            //validate length match
            if (chapter.pages.length !== pages.length) {
                console.log("ERROR: Page count mismatch between saved LMS data and course data. Resetting progress from chapter " + (index + 1) + " forward.");
                err = true;
            }
            pages.map((p, i) => {
                ps.push(err ? 0 : parseInt(pages[i]));
            })
            result.push(ps)
        })

        return result;
    }

    const gotoPrevious = () =>{
        dispatch(gotoPreviousPage())
    }

    const createAlert = (data) =>{
        switch (data.id){
            case "previous":
                return <Alert data={data} confirm={gotoPrevious}/>
                break;

            case "exit":
                return <Alert data={data} confirm={()=>{window.top.close()}}/>
                break;
        }

    }

    const initializePageStatus = (data) => {
        let st = [];
        data.content.map((chapter) => {
            let pages = [];
            chapter.pages.map(() => {
                pages.push(0)
            })
            st.push(pages)
        })
        return st;
    }

    const getContent = () => {
        if (!courseData.content) return null
        if (chapterIndex < 0) {
            return <Menu course={courseData}/>
        } else if (!pageLoaded || !pageData) {
            return <div className="placeholder"/>
        } else {
            return <Page content={pageData}/>
        }
    }

    return (
        <div id="player"
             className="player">
            <HeaderNav/>
            {!imagesLoaded && (
                <div className="loading-page">
                    <Loader
                        type="Oval"
                        color="#00BFFF"
                        height={100}
                        width={100}
                    />
                </div>
            )}
            {imagesLoaded && (
                <>
                    <div ref={blocker}
                         className="blocker"/>
                    {(resourcesVisible && courseData.resourcesPath) &&
                    <Resources data={courseData.resourcesPath}
                               initSelection={resourcesSelection}/>
                    }
                    {alertData &&
                        createAlert(alertData)
                    }
                    {
                        getContent()
                    }
                </>
            )}
            {chapterIndex !== -1 ? <FooterNav/> : null}
        </div>
    );
};

const ScormPlayer = withScorm()(Player);

export default ScormPlayer;
